import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Users, Newspaper, Trophy, Image, UserPlus, Mail, Sparkles } from "lucide-react";

export default function Dashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {}); }, []);
  const cards = [
    { label: "Pendaftar PPDB", value: stats.total_applicants, sub: `${stats.new_applicants || 0} baru`, icon: UserPlus, color: "bg-amber-500" },
    { label: "Guru & Staf", value: stats.total_teachers, icon: Users, color: "bg-blue-500" },
    { label: "Berita", value: stats.total_news, icon: Newspaper, color: "bg-rose-500" },
    { label: "Prestasi", value: stats.total_achievements, icon: Trophy, color: "bg-emerald-500" },
    { label: "Galeri", value: stats.total_gallery, icon: Image, color: "bg-indigo-500" },
    { label: "Ekstrakurikuler", value: stats.total_extracurriculars, icon: Sparkles, color: "bg-purple-500" },
    { label: "Pesan Masuk", value: stats.unread_messages, icon: Mail, color: "bg-slate-700" },
  ];
  return (
    <div data-testid="admin-dashboard-page">
      <h1 className="font-serif text-3xl font-bold text-[#0B1D3A]">Dashboard</h1>
      <p className="text-slate-500 mt-1">Ringkasan aktivitas dan konten sekolah.</p>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
        {cards.map((c) => {
          const I = c.icon;
          return (
            <div key={c.label} data-testid={`stat-card-${c.label.toLowerCase().replace(/\s+/g, "-")}`} className="card-elevated p-5">
              <div className={`w-10 h-10 rounded-xl ${c.color} text-white flex items-center justify-center`}><I className="w-5 h-5" /></div>
              <div className="mt-4 text-3xl font-serif font-black text-[#0B1D3A]">{c.value ?? 0}</div>
              <div className="text-xs uppercase tracking-wider text-slate-500 mt-1">{c.label}</div>
              {c.sub && <div className="text-xs text-amber-600 font-semibold mt-1">{c.sub}</div>}
            </div>
          );
        })}
      </div>

      <div className="mt-10 grid lg:grid-cols-2 gap-6">
        <div className="card-elevated p-6">
          <h3 className="font-serif font-bold text-lg text-[#0B1D3A] mb-4">Pendaftar PPDB Terbaru</h3>
          <ul className="space-y-3">
            {(stats.recent_applicants || []).map((a) => (
              <li key={a.id} className="flex justify-between items-center text-sm border-b border-slate-100 pb-2">
                <div>
                  <div className="font-semibold text-[#0B1D3A]">{a.full_name}</div>
                  <div className="text-xs text-slate-500">{a.registration_number} • {a.program_choice}</div>
                </div>
                <span className="px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 text-xs font-semibold">{a.status}</span>
              </li>
            ))}
            {(!stats.recent_applicants || stats.recent_applicants.length === 0) && <li className="text-sm text-slate-500">Belum ada pendaftar.</li>}
          </ul>
        </div>
        <div className="card-elevated p-6">
          <h3 className="font-serif font-bold text-lg text-[#0B1D3A] mb-4">Berita Terbaru</h3>
          <ul className="space-y-3">
            {(stats.recent_news || []).map((n) => (
              <li key={n.id} className="flex gap-3 items-center text-sm border-b border-slate-100 pb-2">
                {n.thumbnail_url && <img src={n.thumbnail_url} alt="" className="w-14 h-10 rounded-md object-cover" />}
                <div className="flex-1">
                  <div className="font-semibold text-[#0B1D3A] line-clamp-1">{n.title}</div>
                  <div className="text-xs text-slate-500">{n.category} • {new Date(n.created_at).toLocaleDateString("id-ID")}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
